<template>
	<div v-loading="loading">
		<div class="tech_title">订货流程图</div>
		<div class="flow_contnet">
			<p class="flow_title">普通用户</p>
			<div class="whdiua" v-html="flow.common_user"></div>
			<!-- <div class="flow_box" >
				<div class="flow_zi" v-for="(itme,i) in commonList" :key="i" >
					<div class="flow_icon" :class="{'flow_long':commonList.length-1 != i}">
						<img :src="itme.imgsrc"/>
						<div>{{itme.name}}</div>
					</div>
					<div class="flow_brief" v-for="(val) in itme.children" :key="val">•{{val}}</div>
				</div>
			</div> -->
			<p class="flow_title">VIP用户</p>
			<div class="whdiua" v-html="flow.vip_user"></div>
			<!-- <div class="flow_box">
				<div class="flow_zi" v-for="(itme,i) in vipList" :key="i" >
					<div class="flow_icon" :class="{'flow_long':vipList.length-1 != i}">
						<img :src="itme.imgsrc"/>
						<div>{{itme.name}}</div>
					</div>
					<div class="flow_brief" v-for="(val) in itme.children" :key="val">•{{val}}</div>
				</div>
			</div> -->
			<div v-if="user.type!=1" @click="xin.goUrl('/applyVip')" class="confirm_vip laing_btn">
				VIP申请
			</div>
			<div class="tech_zdmk">
				<div v-html="flow.vip_apply_way"></div>
			</div>
			<div class="tech_zdmk">
				<div v-html="cha"></div>
			</div>
			<div class="tech_title">VIP申请：</div>
			<div class="tech_zdmk" v-html="flow.vip_apply">
			</div>
		</div>
	</div>
</template>

<script>
import {mapState} from 'vuex'
	export default{
		data(){
			return {
				loading:true,
				cha:'',
				flow:{},//
				// commonList:[
				// 	{
				// 		imgsrc:require("@/assets/images/flow1.png"),
				// 		name:"查找商品"
				// 	},
				// 	{
				// 		imgsrc:require("@/assets/images/flow2.png"),
				// 		name:"提交订单",
				// 		children:['填写收货人信息','填写开票信息']
				// 	},
				// 	{
				// 		imgsrc:require("@/assets/images/flow6.png"),
				// 		name:"先付款"
				// 	},
				// 	{
				// 		imgsrc:require("@/assets/images/flow4.png"),
				// 		name:"发货",
				// 		children:['现货直接发货','期货需确认货期']
				// 	},
				// 	{
				// 		imgsrc:require("@/assets/images/flow3.png"),
				// 		name:"确认发货"
				// 	}
				// ],
				// vipList:[
				// 	{
				// 		imgsrc:require("@/assets/images/flow1.png"),
				// 		name:"查找商品"
				// 	},
				// 	{
				// 		imgsrc:require("@/assets/images/flow2.png"),
				// 		name:"提交订单",
				// 		children:['填写收货人信息','填写开票信息','选择账期']
				// 	},
				// 	{
				// 		imgsrc:require("@/assets/images/flow4.png"),
				// 		name:"发货"
				// 	},
				// 	{
				// 		imgsrc:require("@/assets/images/flow3.png"),
				// 		name:"确认收货",
				// 		children:['现货直接发货','期货需确认货期']
				// 	},
				// 	{
				// 		imgsrc:require("@/assets/images/flow5.png"),
				// 		name:"发票账单"
				// 	}
				// ]
			}
		},
		computed: {
			...mapState(['user'])
		},
		created(){
			this.PostorderingProcess();
			this.PostuserCommon();
		},
		methods:{
			async PostuserCommon(){
				let {data} = await this.api.PostuserCommon({name:'vip_apply_ask'});
				this.cha = data;
			},
			async PostorderingProcess(){
				let {data} = await this.api.PostorderingProcess();
				this.flow = data;
				this.loading = false;
			}
		}
	}
</script>

<style lang="scss" scoped>
.whdiua{
	width: 100%;
	/deep/ img{
		max-width: 100% !important;
		height:auto !important;
	}
}
	.confirm_vip{
		width: 40px;
		width: 250px;
		line-height: 40px;
		margin: 50px auto;
	}
	.tech_zdmk{
		margin-top: 20px;
		div{
			color: #666666;
			line-height: 40px;
		}
	}
	.tech_{
		.tech_left{
			float: left;
			font-weight: 500;
			font-size: 20px;
			color: #333333;
		}
		.tech_right{
			float: right;
			&:hover{
				cursor: pointer;
				color: #000;
			}
		}
	}
	
	.flow_contnet{
		margin: 0 40px;
		.flow_box{
			// width: 890px;
			border: 2px dashed #626262;
			border-radius: 20px;
			display: flex;
			justify-content: space-around;
			.flow_long{
				border-right: 2px solid #626262;
			}
			.flow_zi{
				margin: 30px 0;
				.flow_icon{
					padding: 0px 62px;
					width: 60px;
					
					
					img{
						width: 100%;
					}
					div{
						line-height: 24px;
						color: #005599;
						font-size: 14px;
						text-align: center;
					}
				}
				.flow_brief{
					margin: 0 auto;
					width: 110px;
					color: #333333;
					font-size: 14px;
				}
			}
		}
		.flow_title{
			font-size: 24px;
			color: #333;
		}
	}
</style>
